import { gql, useMutation } from '@apollo/client'
import {
  MutationAnnouncementDeleteArgs,
  MutationAnnouncementDeletePayload,
} from 'src/generated'

const MUTATION_ANNOUNCEMENT_DELETE = gql`
  mutation AnnouncementDelete($input: MutationAnnouncementDeleteInput!) {
    announcementDelete(input: $input) {
      deleted
    }
  }
`

const useAnnouncementEditMutation = () => {
  return useMutation<
    { announcementEdit: MutationAnnouncementDeletePayload },
    MutationAnnouncementDeleteArgs
  >(MUTATION_ANNOUNCEMENT_DELETE)
}

export default useAnnouncementEditMutation
